<!-- 新增派单规则 -->
<template>

  <div class="detail-wrap">
    <el-form ref="editForm" :model="tenant">
      <div class="d-header clearfix" style="margin: 0;!important">
        <div class="fl">
          <i class="el-icon-info"/>
          批量新增推送规则
        </div>
        <div class="fr">
<!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
<!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <!-- <b>主信息</b> -->
            </div>

            <div class="iname">
              <div>  <em class="f-red">*</em>
              <span>规则名称:</span>
              <el-input style="width: 200px;" type="text" autocomplete="off" clearable v-model="BasPushRuleBatchDTO.ruleName"
                        >
              </el-input></div>

              <div class="iname">
              <em class="f-red">*</em>

              <span>推送地址:</span>
              <!-- <el-form-item>
                  <template>
                    <el-cascader :props="areaProps" v-model="tenant.userProvince" :clearable="true" style="width: 9vw;"
                                 @change="handleChange" ref="cascaderAddr">
                    </el-cascader>
                  </template>
                </el-form-item> -->
                <el-input style="width: 250px;" type="text" autocomplete="off" clearable v-model="BasPushRuleBatchDTO.pushUrl"
                        >
              </el-input>
            </div>
            </div>




          </div>

          <div style="display: flex;">
            <div class="d-item">
              <div class="title first">
                <!-- <b>服务地区</b> -->
              </div>
              <div class="iname2" style="display: flex;">
                <!-- <div class="item1">
                  <em class="f-red">*</em>
                  <span style="white-space:nowrap">服务地区:</span>
                </div>
                <el-form-item>
                  <template>
                    <el-cascader :props="areaProps" v-model="tenant.userProvince" :clearable="true" style="width: 9vw;"
                                 @change="handleChange" ref="cascaderAddr">
                    </el-cascader>
                  </template>
                </el-form-item> -->
                <el-button type="primary" class="button-sty btn_zdy" @click="showPreconditionDialog2=true">
                  <i class="el-icon-plus"></i>
                  网点服务
                </el-button>
                <el-button style="margin: 5px 0;"
                           type="primary" class="button-sty btn_zdy" @click="handleDeleteItemList1">
                  <i class="el-icon-delete"></i>
                  批量删除
                </el-button>
              </div>
              <div class="tab">
                <vxe-table ref="filterTable" :data="siteName" class="table_item pic_item"

                           :stripe="true"
                           :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{height: 30,isHover: true,padding: 0,}"
                           :row-style="{ fontSize: '12px',  }"
                           show-overflow
                           height="300" :column-config="{ resizable: true }"
                           @checkbox-all="siteNameSelectChangeEvent1"
                           @checkbox-change="siteNameSelectChangeEvent1"
                >
                  <vxe-column type="checkbox" width="40"></vxe-column>
                  <vxe-column field="userMobile" title="网点账号" width="120">
                  </vxe-column>
                  <vxe-column field="userName" title="网点名称" width="80">
                  </vxe-column>


                  <vxe-column title="操作" width="60">
                    <template slot-scope="scope">
                      <div @click="handleDelete(scope.row.id)">
                        <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                    popper-class="tooltip-skin">
                          <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                        </el-tooltip>
                      </div>
                    </template>
                  </vxe-column>
                </vxe-table>


              </div>
            </div>

            <!-- 服务类型 -->
            <div class="d-item">
              <div class="title first">
                <!-- <b>服务类型</b> -->
              </div>
              <div class="iname2" style="display: flex; visibility: hidden;">
                <el-button type="primary" class="button-sty btn_zdy" @click="addAreaData">
                  <i class="el-icon-plus"></i>
                  产品
                </el-button>
                <el-button style="margin: 5px 0;"
                           type="primary" class="button-sty btn_zdy" @click="handleDeleteList">
                  <i class="el-icon-delete"></i>
                  批量删除
                </el-button>
              </div>
              <div>

                <vxe-table
                  class="mytable-scrollbar"
                  :stripe="true"
                  :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                  :row-config="{height: 30,isHover: true,padding: 0,}"
                  :row-style="{ fontSize: '12px',  }"
                  show-overflow
                  height="260" :column-config="{ resizable: true }"
                  resizable
                  row-id="id"
                  :tree-config="{
                  transform: true
                }"
                  :data="tableData"
                  @checkbox-change="selectChangeEvent"
                  @checkbox-all="selectChangeEvent"
                >
                  <vxe-column type="checkbox" width="80" :tree-node="true"></vxe-column>
                  <vxe-column field="serviceTypeName" width="250" title="服务类型"></vxe-column>
                </vxe-table>

              </div>
            </div>
            <div class="d-item">
              <div class="title first">
                <!-- <b>产品类型</b> -->
              </div>
              <div class="iname2" style="display: flex;visibility: hidden;">
                <el-button type="primary" class="button-sty btn_zdy" @click="showItemPop=true">
                  <i class="el-icon-plus"></i>
                  产品
                </el-button>
                <el-button style="margin: 5px 0;"
                           type="primary" class="button-sty btn_zdy" @click="handleDeleteList">
                  <i class="el-icon-delete"></i>
                  批量删除
                </el-button>
              </div>
              <div class="current-info" style="width:240px;">
                <!-- 购买渠道 -->
                <vxe-table
                  class="mytable-scrollbar"
                  :stripe="true"
                  :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                  :row-config="{height: 30,isHover: true,padding: 0,}"
                  :row-style="{ fontSize: '12px',  }"
                  show-overflow
                  height="260" :column-config="{ resizable: true }"
                  resizable
                  row-id="id"
                  :tree-config="{transform: true}"
                  :data="basBuyChannelList"
                  @checkbox-change="buyChannelChangeEvent"
                  @checkbox-all="buyChannelChangeEvent"
                >
                  <vxe-column type="checkbox" width="80" :tree-node="true"></vxe-column>
                  <vxe-column field="buyChannelName" width="150" title="购买渠道"></vxe-column>
                </vxe-table>
              </div>
            </div>

          </div>


          <div style="height:10px"></div>
        </div>

      </div>


    </el-form>
    <!-- <preconditionDialog v-if="showPreconditionDialog" @commit="commitSelectedRow"
                        :visiable.sync="showPreconditionDialog" multi="true"
    /> -->
    <item-pop v-if="showItemPop"
              :visiable.sync="showItemPop"

              @confirm="commitSelectedRow"
              :excludeList="itemList"
    />

    <sitePop v-if="showPreconditionDialog2"
             :visiable.sync="showPreconditionDialog2"
             @confirm="commitSelectedRow1"
             :excludeList="siteName"
    />
  </div>

</template>
<script>
import Tinymce from '@/components/Tinymce';
import preconditionDialog from '@/views/dialogCommon/radioSiteDialog.vue';
import sitePop from '@/views/dialogCommon/duoradioSiteDialog.vue';
import request from "@/router/axios";
import itemPop from "@/components/pop/checkboxItemPop.vue"
import {editPageMixins} from "@/mixins/tabChang";

export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    Tinymce,
    preconditionDialog,
    itemPop,
    sitePop,
  },

  data() {
    return {
      itemList: [],

      showItemPop: false,

      saveDataUrl: '/basic/basPushRule/saveBatch',
      getAreaDataUrl: '/basic/basArea/getList',
      getBrandDataUrl: '/basic/snCompanyBrand/getBrandList',
      getAreaPathDataUrl: '/basic/basArea/getAreaPathList',
      getServerTypeDataUrl: '/basic/basServiceType/getAllTree',
      getItemCategoryDataUrl: '/basic/basItemCategory/getList',
      getBasBuyChannelDataUrl: '/basic/basBuyChannel/getList',

      showPreconditionDialog: false,
      showPreconditionDialog2: false,

      siteName: [],
      siteIdList: [],
      selectedSiteName: [],

      basBuyChannelList : [],
      selectedBasBuyChannelList: [],

      isAllServerType : false,
      isAllBuyChannel : false,

      BasPushRuleBatchDTO : {
        ruleName : null,
        pushUrl : null,
        siteIdList : [],
        serviceTypeIdList : [],
        buyChannelIdList : []
      },

      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },

      checkAll: false,
      isIndeterminate: false,
      activeName: 'first',

      // 基本信息
      tenant: {
        ruleName:'',
        status: 0,
        tenantAttachmentDTOs: []
      },
      showProductCategoryDialog: false,

      area: {
        temp: {},
        checkedArray: []
      },

      serviceType: [],
      itemCategory: [],
      tableData: [],
      tableData1: [],
      areaData: [],
      brandList: [],
      checkedBrand: [],
      siteObj: {
        id: '',
        name: ''
      },
    };
  },

  computed: {},

  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId
  },

  mounted() {
    this.loadBrandOption()
    this.loadServerTypeTableData()
    this.loadItemCategoryTableData()
    this.loadBuyChannelTableData()
  },

  methods: {
        // 弹框选中
        commitSelectedRow(data) {
      console.log(data, '弹框选中')
      let temp = this.itemList
      if (temp.length === 0) {
        this.itemList = data
      } else {
        data.forEach(item => {
          temp.push(item)
        })
      }
    },
    // commitSelectedRow(data) {
    //   this.siteObj.id = data.id
    //   this.siteObj.name = data.name
    //   // this.siteObj.name = data
    // },


    /***************************              品牌                 **************************/
    // 加载品牌
    loadBrandOption() {
      this.$http({
        url: this.getBrandDataUrl,
        method: 'post',
        data: {
          usable: 1
        }
      }).then(res => {
        console.log(res.data.data)
        this.brandList = res.data.data
      })
    },

    // 购买渠道复选框
    buyChannelChangeEvent({records}) {
      this.selectedBasBuyChannelList = records.map(item => item.id)
      console.log('购买渠道选中', this.selectedBasBuyChannelList)
      if (records.length === this.basBuyChannelList.length){
        this.isAllBuyChannel = true;
        console.log("全选购买渠道");
      }else{
        this.isAllBuyChannel = false;
      }
    },

    // 品牌单选
    handleCheckAllChange(val) {
      this.checkedBrand = val ? this.brandList.map(item => item.id) : []
      this.isIndeterminate = false
    },

    // 品牌全选
    handleCheckedBrandChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.brandList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.brandList.length;
    },
    /***************************              品牌                 **************************/


    /***************************              服务类型                 **************************/
    // 一级服务类型加载
    loadServerTypeTableData() {
      this.$http({
        url: this.getServerTypeDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        this.tableData = res.data.data
      })
    },

    // 二级服务类型加载
    loadChildrenMethod({row}) {
      return new Promise(resolve => {
        this.$http({
          url: this.getServerTypeDataUrl,
          method: 'post',
          data: {
            parentId: row.id
          }
        }).then(res => {
          console.log(res.data.data)
          resolve(res.data.data)
        })
      })
    },

    // 服务勾选
    selectChangeEvent({records}) {
      // 拿到所有id
      let temp = records.map(item => item.id)

      // 获取有子类的父id
      let parentTemp = new Set()
      records.forEach(item => {
        if (item.parentId != 0) {
          parentTemp.add(item.parentId)
        }
      })

      // 去除有子类的父id
      let temp1 = []
      temp.forEach(item => {
        if (!parentTemp.has(item)) {
          temp1.push(item)
        }
      })
      this.serverType = temp1
      console.log('checked', this.serverType)
      console.log('records.length', records.length)
      if (records.length === this.tableData.length){
        this.isAllServerType = true;
        console.log("全选服务类型");
      }else{
        this.isAllServerType = false;
      }
    },
    /***************************              服务类型                 **************************/


    // 购买渠道加载
    loadBuyChannelTableData() {
      this.$http({
        url: this.getBasBuyChannelDataUrl,
        data: {},
        method: 'post',
      }).then(res => {
        this.basBuyChannelList = res.data.data
        console.log("this.basBuyChannelList",this.basBuyChannelList)
      })
    },


    /***************************               产品分类                 **************************/
    // 一级产品分类加载
    loadItemCategoryTableData() {
      this.$http({
        url: this.getItemCategoryDataUrl,
        method: 'post',
        data: {
          categoryType: 1,
          usable: 1
        }
      }).then(res => {
        this.tableData1 = res.data.data
      })
    },

    // 产品小类加载
    loadChildrenMethod1({row}) {
      return new Promise(resolve => {
        this.$http({
          url: this.getItemCategoryDataUrl,
          method: 'post',
          data: {
            parentId: row.id
          }
        }).then(res => {
          resolve(res.data.data)
        })
      })
    },

    // 产品勾选
    selectChangeEvent1({records}) {
      console.log(records)
      this.itemCategory = records
    },

    /***************************               产品分类                 **************************/


    /***************************               服务地区                 **************************/
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      request({
        url: this.getAreaDataUrl,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};

        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },

    // 地址三级联动
    handleChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      this.area.temp = {
        id: areaNode[0].value,
        level: areaNode[0].level
      }
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },

    // 添加地区列表
    addAreaData() {
      if (this.area.temp.level < 3) {
        this.$message.warning('请至少选择到市级地址')
      } else {
        if (this.area.temp.level === 4 || this.area.temp.level === 3) {
          this.$http({
            url: this.getAreaPathDataUrl,
            method: 'post',
            data: {
              parentId: this.area.temp.id
            }
          }).then(res => {
            let tempArray = this.areaData
            res.data.data.forEach(item => {
              tempArray.push({
                id: item.id,
                areaNamePath: item.areaNamePath
              })
            })
            this.areaData = this.uniqueArr(tempArray)
          })
        } else if (this.area.temp.level === 5) {
          this.$http({
            url: this.getAreaPathDataUrl,
            method: 'post',
            data: {
              areaId: this.area.temp.id,
            }
          }).then(res => {
            let tempArray = this.areaData
            res.data.data.forEach(item => {
              tempArray.push({
                id: item.id,
                areaNamePath: item.areaNamePath
              })
            })
            this.areaData = this.uniqueArr(tempArray)
          })
        }
      }
    },

    // 网点批量删除
    handleDeleteItemList1() {
      if (this.selectedSiteName.length === 0) {
        this.$message.warning('请先勾选网点')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.selectedSiteName.forEach(item0 => {
            this.siteName = this.siteName.filter(item => item.id !== item0)
          })
          this.selectedSiteName = [];
        })
      }
    },

    // 网点复选框
    siteNameSelectChangeEvent1({records}) {
      this.selectedSiteName = records.map(item => item.id)
      console.log('网点选中', this.selectedSiteName)
    },

    commitSelectedRow1(data) {
      console.log(data, '网点选中')
      let temp = this.siteName
      if (temp.length===0){
        this.siteName=data
      }else {
        data.forEach(item=>{
          temp.push(item)
        })
      }
    },

    // 去重
    uniqueArr(arr) {
      let result = [];
      arr.forEach((item) => {
        if (!result.some(m => m.id === item.id)) {
          result.push(item);
        }
      });
      return result;
    },

    // 单个地区删除
    handleDelete(id) {
      console.log(id)
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.areaData = this.areaData.filter(item => item.id !== id)
      })
    },

    // 批量删除地区
    handleDeleteList() {
      console.log(this.area.checkedArray.length)
      console.log(this.area.checkedArray)
      if (this.area.checkedArray.length === 0) {
        this.$message.warning('请先勾选地址')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.area.checkedArray.forEach(item => {
            this.areaData = this.areaData.filter(item1 => item1.id !== item.id)
          })
          this.area.checkedArray = []
        })
      }
    },

    // 单个地址选中
    areaSelect(data) {
      console.log(data, '选中')
      if (data.checked) {
        this.area.checkedArray.push(data.row)
      } else {
        this.area.checkedArray = this.area.checkedArray.filter(item => item.id !== data.row.id)
      }
    },

    // 地址全选
    areaSelectAll(selection) {
      console.log(selection)
      this.area.checkedArray = []
      let records = selection.records
      records.forEach(item => {
        this.area.checkedArray.push(item)
      })
      console.log(this.area.checkedArray.length)
    },

    /***************************               服务地区                 **************************/




    saveData() {
      this.$baseConfirm('您确定要保存吗？').then(() => {
        if (this.BasPushRuleBatchDTO.ruleName === null || this.BasPushRuleBatchDTO.ruleName === ''){
          this.$message.error('请选择规则名称')
          return
        }
        if (this.BasPushRuleBatchDTO.pushUrl === null || this.BasPushRuleBatchDTO.pushUrl === ''){
          this.$message.error('请选择推送地址')
          return
        }
        if (this.selectedBasBuyChannelList.length === 0) {
          this.$message.error('请选择购买渠道')
          return
        }
        this.$mask.open()


        this.siteIdList = [];
        this.BasPushRuleBatchDTO.siteIdList = [];
        this.BasPushRuleBatchDTO.serviceTypeIdList = [];
        this.BasPushRuleBatchDTO.buyChannelIdList = [];
        if (this.siteName != null && this.siteName.length !== 0) {
          this.siteName.forEach(item => {
            this.siteIdList.push(item.id)
          })
          let temp = this.siteIdList.sort()
          //this.BasPushRuleBatchDTO.siteIdList = temp.join(';')
          this.BasPushRuleBatchDTO.siteIdList = this.siteIdList;
        }
        if (this.serverType != null && this.serverType.length !== 0){
          let temp = this.serverType.sort()
          //this.BasPushRuleBatchDTO.serviceTypeIdList = temp.join(';')
          this.BasPushRuleBatchDTO.serviceTypeIdList = this.serverType;
        }
        if (this.selectedBasBuyChannelList != null && this.selectedBasBuyChannelList.length !== 0){
          let temp = this.selectedBasBuyChannelList.sort()
          //this.BasPushRuleBatchDTO.buyChannelIdList = temp.join(';')
          this.BasPushRuleBatchDTO.buyChannelIdList = this.selectedBasBuyChannelList;
        }

        console.log("this.BasPushRuleBatchDTO.siteIdList",this.BasPushRuleBatchDTO.siteIdList)
        console.log("this.BasPushRuleBatchDTO.serviceTypeIdList",this.BasPushRuleBatchDTO.serviceTypeIdList)
        console.log("this.BasPushRuleBatchDTO.buyChannelIdList",this.BasPushRuleBatchDTO.buyChannelIdList)

        this.$http({
          url: this.saveDataUrl,
          method: `post`,
          data: this.BasPushRuleBatchDTO,
        }).then(() => {
          this.$message.success("保存成功！");
          this.goBackIndex()
          this.$mask.close()

        }).catch(e => {
          console.error(e)
          this.$message.error("保存失败！");
          this.$mask.close()

        })
      })

    },

  },
};

</script>
<style lang="scss" scoped>
::v-deep .vxe-table--render-default .vxe-body--column:not(.col--ellipsis), .vxe-table--render-default .vxe-footer--column:not(.col--ellipsis), .vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
  padding: 8px 0 !important;
}

::v-deep .vxe-table--render-default .vxe-body--column:not(.col--ellipsis), .vxe-table--render-default .vxe-footer--column:not(.col--ellipsis), .vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
  padding: 8px 0 !important;
}

::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #00c4b3 !important;
  border-color: #00c4b3 !important;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #00c4b3;
  border-color: #00c4b3;
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #00c4b3 !important;
}


.tab {
  margin-left: 20px;
}

.table_main {
  width: 28%;
}

.btn_zdy {
  margin: 5px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .vxe-grid .vxe-button.type--button.is--circle {
  display: none;
}

::v-deep .vxe-grid .vxe-table {
  /* overflow: hidden; */
  border: 1px solid #ededed;
  margin-right: 10px;
}

.iname {
  margin-left: 35px;
  display: flex;
    align-items: center;
    flex-direction: row;
  span {
    font-weight: 400;
    text-align: right;
    // width: 112px;
    position: relative;
    font-size: 12px;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.iname2 {
  margin: 0px 15px;


  .item1 {
    line-height: 36px;

    span {
      font-weight: 400;
      text-align: right;
      // width: 112px;
      position: relative;
      font-size: 12px;
      padding: 0 10px 0 4px;
      color: rgba(86, 86, 86, 0.96);
    }
  }

}

.title1 {
  font-weight: 400;
  text-align: right;
  width: 81px;
  position: relative;
  font-size: 12px;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);

}

.brand {
  margin: 20px 0 0px 20px;
  display: flex;

  .brand_item2 {
    margin-left: 20px;
  }

}

#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

.expand-wrapper {
  padding: 10px;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {

  position: absolute !important;
  bottom: -35px !important;

}

#containt .detail-wrap .d-cont {
  overflow: auto !important;
}

#containt .detail-wrap .d-cont .d-item:last-child {
  margin-bottom: 0px;
}
</style>
